import type { THubertButtonVariants } from 'components/HubertUI/HubertButton';
import type { Value } from 'platejs';
import type { ReactNode } from 'react';

export enum EItemType {
  Job = 'job',
  Templates = 'templates',
  Interviews = 'interviews',
  Applications = 'Applications',
  Candidates = 'candidates',
  Questions = 'questions',
  Clients = 'clients',
}

export type TSelectBase = {
  id?: number | string;
  value: string;
  label: string;
  disabled?: boolean;

  variant?: THubertButtonVariants;
  description?: string | ReactNode;
  color?: string;
  onClick?: (value: any, selected?: any) => void;
  icon?: ReactNode;

  backgroundColor?: string;
  textColor?: string;
  borderColor?: string;
  dataValue?: any;
};

export enum EQualifiedState {
  Qualified = 'qualified',
  NotQualified = 'not_qualified',
}

export type TRichTextContentValue = { value: Value; html: string };
